<template>
  <div class="paySetting">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="支付宝" name="first">
          <div class="paySetting-tipsTitle">此支付应用于app、pc端收、费率0.6%，此支付需要开通支付宝对公账号。</div>
          <el-row>
            <el-col :span="12">
              <el-form
                ref="addAliPayForm"
                :model="addAliPayForm"
                :label-width="formLabelWidth"
                :rules="addAliPayFormRules"
              >
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="appid" prop="appid">
                      <el-input
                        v-model="addAliPayForm.appid"
                        placeholder="appid"
                        auto-complete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="合作伙伴身份（PID）" prop="pid">
                      <el-input
                        v-model="addAliPayForm.pid"
                        placeholder="合作伙伴身份（PID）"
                        auto-complete="off"
                      ></el-input>
                      <div class="paySetting-tips">账户管理-商户信息管理-查看PIDIKEY</div>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="MD5密钥" prop="md5Key">
                      <el-input v-model="addAliPayForm.md5Key" placeholder="MD5密钥" auto-complete="off"></el-input>
                      <div class="paySetting-tips">账户管理-商户信息管理-查看PIDIKEY-MD5密钥</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="RSA密钥" prop="rsaKey">
                      <el-input v-model="addAliPayForm.rsaKey" placeholder="RSA密钥" auto-complete="off"></el-input>
                      <div class="paySetting-tips">RSA密钥，用于H5内支付宝支付</div>
                      <div class="paySetting-tips">账户管理-商户信息管理-查看PIDIKEY-RSA密钥</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="12">
              <div class="paySetting-right">
                <div class="paySetting-right-tips">
                  企业支付宝账号申请
                  <el-link type="primary" href="https://memberprod.alipay.com/account/reg/enterpriseIndex.htm" target="_blank">https://memberprod.alipay.com/account/reg/enterpriseIndex.htm</el-link>
                </div>
                <div class="paySetting-right-tips">
                  支付宝支付前置申请
                  <el-link type="primary" href="https://b.alipay.com/index2.htm" target="_blank">https://b.alipay.com/index2.htm</el-link>
                </div>
                <div class="paySetting-right-tip">支付宝信息设置 如何使用支付信息设置</div>
                <!-- <el-button class="paySetting-right-button">文档使用操作</el-button> -->
              </div>
            </el-col>
          </el-row>
          <div>
            <el-button style="margin-left:150px" type="primary" @click="aliPaySubmit()">保存</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="微信支付" name="second">
          <div class="paySetting-tipsTitle">此支付应用于app、微信公众号、pc端收款、费率0.6%，此支付需要开通微信对公账号。</div>
          <el-row>
            <el-col :span="12">
              <el-form
                ref="addWecharPayForm"
                :model="addWecharPayForm"
                :label-width="formLabelWidth"
                :rules="addWecharPayFormRules"
              >
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="Appid" prop="appid">
                      <el-input
                        v-model="addWecharPayForm.appid"
                        placeholder="Appid"
                        auto-complete="off"
                      ></el-input>
                      <div class="paySetting-tips">开发者ID（Appid），如使用微信支付，必须填写</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="商户号" prop="merchant">
                      <el-input
                        v-model="addWecharPayForm.merchant"
                        placeholder="商户号"
                        auto-complete="off"
                      ></el-input>
                      <div class="paySetting-tips">产品中心-开发者配置-商户号</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="支付密钥" prop="appKey">
                      <el-input
                        v-model="addWecharPayForm.appKey"
                        placeholder="支付密钥"
                        auto-complete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="AppSecret" prop="appSecret">
                      <el-input
                        v-model="addWecharPayForm.appSecret"
                        placeholder="AppSecret"
                        auto-complete="off"
                      ></el-input>
                      <div class="paySetting-tips">开发者密码（AppSecret），用于在微信内支付，其他方式可不填</div>
                      <div class="paySetting-tips">账户管理-商户信息管理-查看PIDIKEY-RSA密钥</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="微信公众号支付验证文件">
                      <el-upload
                          class="avatar-uploader-logo"
                          action=""
                          :http-request="wechatpayFileUploadRequest"
                          :show-file-list="false"
                        >
                          <el-button>上传</el-button>
                          <i v-if="addWecharPayForm.wechatPayFile" class="paySetting-success el-icon-success"></i>
                        </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="12">
              <div class="paySetting-right">
                <div class="paySetting-right-tips">
                  企业微信支付账号申请
                  <el-link type="primary" href="https://pay.weixin.qq.com/static/applyment_guide/applyment_detail_qiye.shtml" target="_blank">https://pay.weixin.qq.com/static/applyment_guide/applyment_detail_qiye.shtml</el-link>
                </div>
                <div class="paySetting-right-tips">
                  微信支付前置申请
                  <el-link type="primary" href="https://pay.weixin.qq.com/static/applyment_guide/applyment_detail_qiye.shtml" target="_blank">https://pay.weixin.qq.com/static/applyment_guide/applyment_detail_qiye.shtml</el-link>
                </div>
                <div class="paySetting-right-tip">支付宝信息设置 如何使用支付信息设置</div>
                <!-- <el-button class="paySetting-right-button">文档使用操作</el-button> -->
              </div>
            </el-col>
          </el-row>
          <div>
            <el-button style="margin-left:150px" type="primary" @click="WecharPaySubmit()" :loading="WecharPaySubmitLoading">保存</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="个人二维码收款" name="third">
          <div
            class="paySetting-tipsTitle"
          >1、若设置个人二维码收款，"支付宝商家收款、微信支付商家收款"二种收款方式将失效，学生将只能通过扫描个人二维码付款。</div>
          <div class="paySetting-tipsTitle">2、若设置个人二维码收款，支付宝收款码和微信收款码至少上传一个。</div>
          <el-row>
            <el-col :span="12">
              <el-form
                ref="addIndividualPayForm"
                :model="addIndividualPayForm"
                :label-width="formLabelWidth"
                :rules="addIndividualPayFormRules"
              >
                <el-row>
                  <el-col :sm="24" :md="24" :lg="16">
                    <el-form-item label="支付宝收款码" prop="logo">
                      <div>
                        <el-upload
                          class="avatar-uploader-logo"
                          action=""
                          :http-request="alipayUploadRequest"
                          :show-file-list="false"
                        >
                          <i class="el-icon-plus avatar-uploader-icon"></i>
                          <img class="paySetting-image" style="margin-left:20px" v-if="addIndividualPayForm.alipayQrcode" :src="addIndividualPayForm.alipayQrcode" height="150" width="150">
                        </el-upload>
                      </div>
                      <div class="paySetting-tips">图片大小不能超过1M，仅支持jpg、png格式，最佳尺寸为200*200。</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="16">
                    <el-form-item label="微信收款码" prop="logo">
                      <div>
                        <el-upload
                          class="avatar-uploader-logo"
                          action=""
                          :http-request="wechatpayUploadRequest"
                          :show-file-list="false"
                        >
                          <i class="el-icon-plus avatar-uploader-icon"></i>
                          <img class="paySetting-image" style="margin-left:20px" v-if="addIndividualPayForm.wechatpayQrcode" :src="addIndividualPayForm.wechatpayQrcode" height="150" width="150">
                        </el-upload>
                      </div>
                      <div class="paySetting-tips">图片大小不能超过1M，仅支持jpg、png格式，最佳尺寸为200*200。</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :md="24" :lg="24">
                    <el-form-item label="联系号码" prop="tel">
                      <el-input
                        v-model="addIndividualPayForm.tel"
                        placeholder="联系号码"
                        auto-complete="off"
                      ></el-input>
                      <div class="paySetting-tips">联系号码请务必正确填写，学生需通过该联系方式联系机构开通课程。</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
          <div>
            <el-button style="margin-left:150px" type="primary" @click="individualPaySubmit()" :loading="individualPaySubmitLoading">保存</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
import { uploadOSS } from '../../upload/upload'
export default {
  data() {
    let that = this;
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系号码"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          var reg2 = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
          if (!reg.test(value)&&!reg2.test(value)) {
            callback(new Error("请输入正确的联系号码"));
          }
        }
        callback();
      }
    };
    return {
      activeName: "first",
      aliPaySubmitLoading: false,
      WecharPaySubmitLoading: false,
      individualPaySubmitLoading: false,
      aliPayEditBlock: false,
      WecharPayEditBlock: false,
      individualPayEditBlock: false,
      addAliPayForm: {
        // alipayAccount: null,
        appid: null,
        md5Key: null,
        rsaKey: null,
        type: 1,
      },
      addWecharPayForm: {
        appid: null,
        merchant: null,
        appKey: null,
        appSecret: null,
        wechatPayFile: null,
        type: 2
      },
      addIndividualPayForm: {
        alipayQrcode: null,
        wechatpayQrcode: null,
        type: 3,
        tel: null
      },
      formLabelWidth: "150px",
      addAliPayFormRules: {
        // alipayAccount: [
        //   {
        //     required: true,
        //     message: "请输入支付宝账号",
        //     trigger: "blur"
        //   }
        // ],
        // pid: {
        //   required: true,
        //   message: "请输入合作伙伴身份（PID）",
        //   trigger: "change"
        // },
        appid: {
          required: true,
          message: "请输入appid",
          trigger: "change"
        },
        md5Key: {
          required: true,
          message: "请输入MD5密钥",
          trigger: "change"
        },
        rsaKey: {
          required: true,
          message: "请输入RSA密钥",
          trigger: "change"
        },
      },
      addWecharPayFormRules: {
        appid: [
          {
            required: true,
            message: "请输入开发者ID（Appid）",
            trigger: "blur"
          }
        ],
        merchant: {
          required: true,
          message: "请输入商户号",
          trigger: "blur"
        },
        appKey: {
          required: true,
          message: "请输入支付密钥",
          trigger: "blur"
        },
        appSecret: {
          required: true,
          message: "请输入开发者密码（AppSecret）",
          trigger: "blur"
        },
      },
      addIndividualPayFormRules: {
        tel: [
          {
          required: true,
          message: "请输入联系号码",
          trigger: "blur"
          },
          {
          validator: validateMobile,
          trigger: "blur"
        },
        ]
      }
    };
  },
  methods: {
     /*----------------------------tab标签跳转----------------------------- */
    handleClick(tab, event) {
      if(tab.index == '0'){
        this.getPaymentSetting();
      }
      else if(tab.index == '1'){
        this.getWecharPaymentSetting();
      }
      else if(tab.index == '2'){
        this.getIndividualPaymentSetting();
      }
    },


    /*----------------------------支付宝支付----------------------------- */
    getPaymentSetting(){
      this.api.paymentSetting.getPaymentSetting({type:1}).then(result=>{
        if (result.success) {
          if(result.data!=null){
            this.addAliPayForm = result.data;
            this.aliPayEditBlock = true;
          }else{

          }

        } else {
          this.$message.error(result.message);
        }
      })
    },
    aliPaySubmit(){
      if(this.aliPaySubmitLoading){
        return
      }
      this.$refs.addAliPayForm.validate(valid => {
        if (valid) {
          this.aliPaySubmitLoading = true;
          if(this.aliPayEditBlock){
            this.updatePaymentSetting();
          }else{
            this.addPaymentSetting();
          }
        }
      })
    },
    addPaymentSetting(){
      this.api.paymentSetting.addPaymentSetting(this.addAliPayForm).then(result=>{
        if(result.success){
          this.aliPaySubmitLoading = false;
          this.aliPayEditBlock = true;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },
    updatePaymentSetting(){
      this.api.paymentSetting.updatePaymentSetting(this.addAliPayForm).then(result=>{
        if(result.success){
          this.aliPaySubmitLoading = false;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },



    /*----------------------------微信支付----------------------------- */
    getWecharPaymentSetting(){
      this.api.paymentSetting.getPaymentSetting({type:2}).then(result=>{
        if (result.success) {
          if(result.data!=null){
            this.addWecharPayForm = result.data;
            this.WecharPayEditBlock = true;
          }else{

          }
        } else {
          this.$message.error(result.message);
        }
      })
    },
    WecharPaySubmit(){
      if(this.WecharPaySubmitLoading){
        return
      }
      this.$refs.addWecharPayForm.validate(valid => {
        if (valid) {
          this.WecharPaySubmitLoading = true;
          if(this.WecharPayEditBlock){
            this.upWecharPaymentSetting();
          }else{
            this.addWecharPaymentSetting();
          }
        }
      })
    },
    addWecharPaymentSetting(){
      this.api.paymentSetting.addPaymentSetting(this.addWecharPayForm).then(result=>{
        if(result.success){
          this.WecharPaySubmitLoading = false;
          this.WecharPayEditBlock = true;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },
    upWecharPaymentSetting(){
      this.api.paymentSetting.updatePaymentSetting(this.addWecharPayForm).then(result=>{
        if(result.success){
          this.WecharPaySubmitLoading = false;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },


    /*----------------------------个人支付----------------------------- */
    alipayUploadRequest(file) {
      const isJPG = file.file.type === 'image/jpeg'||file.file.type ==='image/png';
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/png 格式!');
        return;
      }
      if(file.file.size/1024/1024>1){
        this.$message.error("图片大小不能超过1M");
      }else{
        uploadOSS(file, "Setting").then(result=>{
          this.$set(this.addIndividualPayForm,'alipayQrcode',result);
        })
      }
    },
    wechatpayUploadRequest(file) {
      const isJPG = file.file.type === 'image/jpeg'||file.file.type ==='image/png';
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/png 格式!');
        return;
      }
      if(file.file.size/1024/1024>1){
        this.$message.error("图片大小不能超过1M");
      }else{
        uploadOSS(file, "Setting").then(result=>{
          this.$set(this.addIndividualPayForm,'wechatpayQrcode',result);
        })
      }
    },
    wechatpayFileUploadRequest(file) {
        uploadOSS(file, "Setting").then(result=>{
          this.$message.success("上传成功！")
          this.$set(this.addWecharPayForm,'wechatPayFile',result);
        })
    },
    getIndividualPaymentSetting(){
      this.api.paymentSetting.getPaymentSetting({type:3}).then(result=>{
        if (result.success) {
          if(result.data!=null){
            this.addIndividualPayForm = result.data;
            this.individualPayEditBlock = true;
          }else{

          }
        } else {
          this.$message.error(result.message);
        }
      })
    },
    individualPaySubmit(){
      if(this.individualPaySubmitLoading){
        return
      }
      if(!this.addIndividualPayForm.wechatpayQrcode&&!this.addIndividualPayForm.alipayQrcode){
        this.$message.error("若设置个人二维码收款，支付宝收款码和微信收款码至少上传一个")
      }else{
        this.$refs.addIndividualPayForm.validate(valid => {
          if (valid) {
            this.individualPaySubmitLoading = true;
            if(this.individualPayEditBlock){
              this.updataIndividualPaymentSetting();
            }else{
              this.addIndividualPaymentSetting();
            }
          }
        })
      }
    },
    addIndividualPaymentSetting(){
      this.api.paymentSetting.addPaymentSetting(this.addIndividualPayForm).then(result=>{
        if(result.success){
          this.individualPaySubmitLoading = false;
          this.individualPayEditBlock = true;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },
    updataIndividualPaymentSetting(){
      this.api.paymentSetting.updatePaymentSetting(this.addIndividualPayForm).then(result=>{
        if(result.success){
          this.individualPaySubmitLoading = false;
          this.$message.success(result.message);
        }else{
          this.$message.error(result.message);
        }
      })
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getPaymentSetting();
  }
};
</script>
<style scoped>
.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.paySetting-tipsTitle {
  color: rgb(65, 121, 158);
  margin-left: 150px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.paySetting-tips {
  color: rgb(122,122,122);
}
.paySetting-right {
  margin-top: 20px;
  margin-left: 100px;
}
.paySetting-right-tip {
  font-size: 20px;
  font-weight: 800;
  margin-top: 20px;
}
.paySetting-right-tips {
  line-height: 30px;
  font-size: 14px;
}
.paySetting-right-button {
  margin-top: 20px;
  color: #fff;
  background: rgb(255, 143, 1);
}
.paySetting-image{
  border-radius: 4px;
}
.paySetting-success{
  margin-left: 20px;
  line-height: 40px;
  font-size: 20px;
  color: #409EFF;
  /* vertical-align: middle; */
}
</style>
<style lang="less">
  .el-upload{
    // display: inline-flex!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/paySetting.vue